module.exports = "<div class=\"kan-user-list\">\n    <!--<div class=\"kan-spinner-container\"-->\n         <!--*ngIf=\"loading\">-->\n        <!--<mat-spinner color=\"primary\"></mat-spinner>-->\n    <!--</div>-->\n    <kan-user-list-item *ngFor=\"let user of users\"\n                        [user]=\"user\"\n                        [searchText]=\"searchText\"\n                        (refresh)=\"emitRefresh()\">\n    </kan-user-list-item>\n</div>\n\n"


//////////////////
// WEBPACK FOOTER
// ./src/modules/admin/components/user/list/component.html
// module id = ./src/modules/admin/components/user/list/component.html
// module chunks = main